import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getScheduleAnalyses, 
  getScheduleAnalysis, 
  clearLocalScheduleAnalyses, 
  clearLocalActiveScheduleAnalysis 
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  scheduleAnalysis: { 
    id: '', 
    result: '', 
    patient: null,
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false,  
    scheduleAnalysis: false
  }
};

const slice = createSlice({
  name: 'scheduleAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getScheduleAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getScheduleAnalyses.fulfilled, (state, action) => {
        const { schedule_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...schedule_analyses], 'id');

        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getScheduleAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getScheduleAnalysis.pending, (state) => {
        state.loading.scheduleAnalysis = true;
      })
      .addCase(getScheduleAnalysis.fulfilled, (state, action) => {
        const { data: { schedule_analysis }, cable } = action.payload;
        const foundedScheduleAnalysis = !!_find(state.all.data, (s) => s.id === schedule_analysis.id);
        const updatedScheduleAnalysis = { ...state.scheduleAnalysis, ...schedule_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedScheduleAnalysis ? _map(state.all.data, (e) => e.id === schedule_analysis.id ? { ...e, ...schedule_analysis } : e) : [...[schedule_analysis], ...oldAllData]; 
        const pagination = foundedScheduleAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.scheduleAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedScheduleAnalysis && !cable) state.scheduleAnalysis = updatedScheduleAnalysis;       
      })
      .addCase(getScheduleAnalysis.rejected, (state) => {
        state.loading.scheduleAnalysis = false;
      })
      .addCase(clearLocalScheduleAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveScheduleAnalysis, state => {
        state.scheduleAnalysis = initialState.scheduleAnalysis;
      })
  }
})

export default slice.reducer;